import ChatService from "../front-services/ChatService";
import Colors from "./Colors";

const HM_STYLE = {
  text: {
    color: "#000",
  },
  messages: {
    user: {
      color: "#fff6d7",
    },
    bot: {
      color: "#f2f6ff",
      icon: "https://firebasestorage.googleapis.com/v0/b/plutonios-prod.appspot.com/o/HM%2Fsecondary_logo_50_50.webp?alt=media&token=3d3582af-b29c-4136-aa0f-45c8720b2f10",
    },
  },
  open_button: {
    image:
      "https://firebasestorage.googleapis.com/v0/b/plutonios-prod.appspot.com/o/HM%2Fsecondary_logo_200_200.webp?alt=media&token=212f3193-aaf6-4b95-9dd1-62ded26be8c9",
  },
};

const FALLBACK_IMAGE =
  "https://firebasestorage.googleapis.com/v0/b/plutonios-prod.appspot.com/o/widget-chat%2Freceptionist.png?alt=media&token=b5587462-0e18-425e-a985-50b8ebf457ca";

const DEFAULT_STYLE = (style: any) => ({
  text: {
    color: "white",
  },
  messages: {
    user: {
      color: Colors.lightenHexColor(style.color, 85),
    },
    bot: {
      color: Colors.lightenHexColor(style.color, 5),
      icon: style.bot_icon || style.open_button_image || FALLBACK_IMAGE,
    },
  },
  open_button: {
    image: style.open_button_image || FALLBACK_IMAGE,
  },
});

export default function getInternalStyle(assistant_id: any, style: any) {
  if (ChatService.isHM(assistant_id)) return HM_STYLE;
  else return DEFAULT_STYLE(style);
}
